// extracted by mini-css-extract-plugin
export default {"container":"HOCoQJ","isFluid":"EooSKF"};